// removed by extract-text-webpack-plugin
module.exports = {"container":"pages-contact-container","content":"pages-contact-content","inner":"pages-contact-inner","header":"pages-contact-header","mapSection":"pages-contact-mapSection","title":"pages-contact-title","section":"pages-contact-section","col":"pages-contact-col","cols":"pages-contact-cols","blocks":"pages-contact-blocks","list":"pages-contact-list","large":"pages-contact-large","map":"pages-contact-map"};


//////////////////
// WEBPACK FOOTER
// ./styles/pages/contact.scss
// module id = 826
// module chunks = 246